import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import React, { Component } from 'react';
import Box from '../Box';
import { ItemList } from '../ItemList';
import ComboboxInput from './ComboboxInput';
import ComboboxItem from './ComboboxItem';
import ComboboxItems from './ComboboxItems';
import ComboboxPopover from './ComboboxPopover';

var Combobox = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Combobox, _Component);

  function Combobox() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Combobox.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        multiple = _this$props.multiple,
        onSelect = _this$props.onSelect,
        selectedValue = _this$props.selectedValue,
        restProps = _objectWithoutPropertiesLoose(_this$props, ["children", "multiple", "onSelect", "selectedValue"]);

    return /*#__PURE__*/React.createElement(ItemList, {
      selected: function selected(item) {
        return item.value === selectedValue;
      },
      onSelect: onSelect
    }, /*#__PURE__*/React.createElement(Box, restProps, children));
  };

  return Combobox;
}(Component);

_defineProperty(Combobox, "Input", ComboboxInput);

_defineProperty(Combobox, "Item", ComboboxItem);

_defineProperty(Combobox, "Items", ComboboxItems);

_defineProperty(Combobox, "Popover", ComboboxPopover);

export default Combobox;